import { useDispatch, useSelector } from "react-redux";
import React, { useContext, useEffect } from "react";
import { Button, Card, Space, theme } from "antd";
import { IoAdd } from "react-icons/io5";
import {
  clearResponsables,
  getResponsables,
} from "../ResponsablesSlice/Responsables.slice";
import { objectToUrlParams } from "../../../../utils/helpersFunction";
import { ResponsableItem } from "../ResponsableItem/ResponsableItem";
import { UserHasLevel } from "../../../../engine/AuthRoute";
import routes from "../../../../engine/routes";
import { ModalContext } from "../../../../engine/context/Modal.provider";
import { CreateApplicant } from "../../../components/CreateApplicant/CreateApplicant";
import { useTranslation } from "react-i18next";

export const ResponsablesList = ({
  institution = null,
  search = {},
  principal = null,
}) => {
  const { t } = useTranslation(); // Initialize useTranslation
  const { loading, responsables } = useSelector(state => state.responsables);

  const context = useContext(ModalContext);

  const dispatch = useDispatch();

  const {
    token: { colorPrimary },
  } = theme.useToken();

  const dispatchActionGetResponsables = () => {
    const search = objectToUrlParams({
      institution: institution?._id,
      principal: principal?._id,
    });

    dispatch(getResponsables(search));
  };

  useEffect(() => {
    dispatchActionGetResponsables();

    return () => {
      dispatch(clearResponsables());
    };
  }, [institution, principal]);

  return (
    <>
      <Space direction={"vertical"} size={"middle"} style={{ width: "100%" }}>
        <UserHasLevel rule={routes.institutions().responsables} action={"c"}>
          <CreateApplicant
            institution={institution}
            key={Math.random()}
            name={"intervenant"}
            onCreated={_id => {
              dispatchActionGetResponsables();
            }}
            opener={
              <Button
                style={{ flex: 1, width: "100%", fontWeight: 600 }}
                size={"large"}
                type={"dashed"}
                danger
              >
                <IoAdd style={{ margin: 0, color: colorPrimary }} size={30} />
                {t("responsablesList.addResponsable")}
              </Button>
            }
          />
        </UserHasLevel>
        {loading ? (
          <>
            <Card loading={true} style={{ width: "100%" }}></Card>
            <Card loading={true} style={{ width: "100%" }}></Card>
            <Card loading={true} style={{ width: "100%" }}></Card>
          </>
        ) : (
          responsables.map(responsable => (
            <ResponsableItem
              institution={institution}
              principal={principal}
              responsable={responsable}
              key={responsable._id}
            />
          ))
        )}
      </Space>
    </>
  );
};
